import { NavLink, useLocation } from 'react-router-dom';
import { Home, Mic, BookOpen, User, Sparkles } from 'lucide-react';

const ONIRVA_ICON = "https://customer-assets.emergentagent.com/job_200ec0e0-0820-4417-b1b5-b6286eb18bc4/artifacts/c3nyk9fu_80AC8250-CA42-4BF9-BA0D-F1211AA6A764.png";

const NAV_ITEMS = [
  { path: '/dashboard', icon: Home, label: 'Home' },
  { path: '/capture', icon: Mic, label: 'Record' },
  { path: '/journal', icon: BookOpen, label: 'Journal' },
  { path: '/intelligence', icon: Sparkles, label: 'Insights' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export function TopNav() {
  const location = useLocation();
  
  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] bg-background border-b border-white/10" data-testid="top-nav">
      <div className="max-w-screen-xl mx-auto px-3 sm:px-4">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <NavLink to="/dashboard" className="flex items-center gap-2 shrink-0">
            <img src={ONIRVA_ICON} alt="ONIRVA" className="w-8 h-8 rounded-lg" />
            <span className="font-serif font-bold text-lg">ONIRVA</span>
          </NavLink>
          
          {/* Nav Items */}
          <div className="flex items-center gap-0.5 sm:gap-1">
            {NAV_ITEMS.map(({ path, icon: Icon, label }) => {
              const isActive = location.pathname === path || 
                (path === '/capture' && location.pathname.startsWith('/capture'));
              
              return (
                <NavLink
                  key={path}
                  to={path}
                  className={`flex items-center gap-1.5 px-2 sm:px-3 py-2 rounded-lg transition-colors ${
                    isActive 
                      ? 'text-primary bg-primary/10' 
                      : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
                  }`}
                  data-testid={`nav-${label.toLowerCase()}`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="text-xs sm:text-sm hidden sm:block">{label}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}

// Keep BottomNav as alias for backwards compatibility
export const BottomNav = TopNav;
export default TopNav;
